<template>
  <div class="notification-container border-box">
    <div class="logo">
      <img src="https://wemeet-1302608036.cos.ap-shanghai.myqcloud.com/WeMeetStatic/huisheng-logo.png" alt="">
    </div>
    <!-- 大标题 -->
    <div class="title-box">
      <span class="top">付款通知单</span>
      <span class="bottom">Debit Note</span>
    </div>
    <!-- 信息1 -->
    <div class="info info1">
      <div class="list list-left">
        <div class="left ">
          <div class="top">公司/客户：</div>
          <div class="bottom">Payment Details：</div>
        </div>
        <div class="right">{{company}}</div>
      </div>
      <div class="list list-right">
        <div class="left ">
          <div class="top">联系人：</div>
          <div class="bottom">Contact Person：</div>
        </div>
        <div class="right">{{name}}</div>
      </div>
      <div class="list list1 list-left">
        <div class="left ">
          <div class="top">地址：</div>
          <div class="bottom">Desk Number：</div>
        </div>
        <div class="right">{{address}}</div>
      </div>
      <div class="list list1 list-right">
        <div class="left ">
          <div class="top">联系电话：</div>
          <div class="bottom">Phone No：</div>
        </div>
        <div class="right">{{phone}}</div>
      </div>
    </div>
    <!-- 表格 -->
    <customTable></customTable>
    <!-- 付款信息 -->
    <div class="pay-container">
      <!-- 付款信息: -->
      <div class="list ">
        <div class="left pay-info-title">
          <div class="top">付款信息:</div>
          <div class="bottom">Payment Details:</div>
        </div>
        <div class="right"></div>
      </div>
      <!-- 公司名称: -->
      <div class="list list1">
        <div class="left">
          <div class="top">公司名称:</div>
          <div class="bottom">Company Name:</div>
        </div>
        <div class="right">上海荟神数科网络有限公司</div>
      </div>
      <!-- 人民币账号: -->
      <div class="list list1">
        <div class="left">
          <div class="top">人民币账号:</div>
          <div class="bottom">Account Number:</div>
        </div>
        <div class="right">121951554610301</div>
      </div>
      <!-- 开户银行: -->
      <div class="list list1">
        <div class="left">
          <div class="top">开户银行:</div>
          <div class="bottom">Name of the Bank:</div>
        </div>
        <div class="right">招商银行股份有限公司上海田林支行</div>
      </div>
    </div>
    <!-- 注意事项 -->
    <div class="notice-item-container">
      <div class="title">注：Note：</div>
      <div class="zh-desc">如果您已经付款，很抱歉给您带来不便，请忽略此账单。</div>
      <div class="en-desc">Sorry for any inconvenience caused if you already paid. please ignore it.</div>
    </div>
  </div>
</template>
<script>
import customTable from './components/customTable.vue'
export default {
  name: '',
  props: {},
  components: { customTable },
  data() {
    return {
      company: '',
      name: '',
      address: '',
      phone: '',
    }
  },
  methods: {},
  mounted() {
    const { company, name, address, phone } = this.$route.query
    this.company = company
    this.name = name
    this.address = address
    this.phone = phone
  },
}
</script>
<style lang="less" scoped>
  .border-box { box-sizing: border-box; }
  .notification-container {
    min-height: 100vh;
    max-width: 900px;
    // margin: 0 auto;
    background-color: #F5F5F5;
    padding: 46px 30px 30px;
    
    .logo {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 377px;
        height: 62px;
      }
    }
    .title-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      color: #000;
      width: 100%;
      margin-top: 66px;
      .top {
        font-size: 30px;
        font-weight: 700;
      }
      .bottom {
        margin-top: 3px;
        font-size: 28px;
        font-weight: 700;
      }
    }
    .info {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      font-size: 20px;
      color: #000;
      font-weight: 700;
      margin-top: 30px;
      &.info1 {
        margin-top: 70px;
      }
      .list {
        display: flex;
        width: 50%;
        box-sizing: border-box;
        &.list-left {
          padding-right: 6px;
        }
        &.list-right {
          padding-left: 6px;
        }
        &.list1 {
          margin-top: 32px;
        }
        .left {
          display: flex;
          flex-flow: column wrap;
          white-space: nowrap;
          flex:1;
          &.pay-info-title {
            font-size: 16px;
            font-weight: 700;
          }
        }
        .right {
          flex:2;
          padding-top: 8px;
          font-weight: normal;
        }
      }
    }
    // 付款信息
    .pay-container {
      margin-top:46px;
      font-size: 20px;
      color: #000;
      .list {
        display: flex;
        align-items: center;
        &.list1 {
          margin-top: 18px;
        }
        .left {
          display: flex;
          flex-flow: column wrap;
          width: 105px;
          flex:1.2;
          &.pay-info-title {
            font-size: 24px;
            font-weight: 700;
          }
        }
        .right {
          flex:2;
        }
      }
    }
    // 注意事项
    .notice-item-container {
      margin-top: 40px;
      font-size: 20px;
      color: #000;
      overflow: hidden;
      .title {
        font-weight: 700;
      }
      .zh-desc {
          margin-top: 18px;
          font-size: 20px;
          color: #262626;
        }
        .en-desc {
          margin-top: 2px;
          color: #262626;
          font-size: 18px;
        }
    }
  }
</style>